import React from 'react'

const Icon = ({
    style,
    onClick,
    icon_style,
    icon_className
}) => {
    return <i
        className={`${icon_style} ${icon_className}`}
        onClick={onClick}
        style={style}
    />
}

export default Icon;
